import React from 'react';
import { IconButton, Typography, Box } from '@mui/material';
import { useTheme } from '../theme/ThemeContext';
import { colorPalette } from '../theme/colorPalette';

const ThemeToggle = () => {
    const { mode, toggleTheme } = useTheme();
    const colors = colorPalette[mode];

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 1,
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    fontFamily: 'Varela Round, sans-serif',
                    fontSize: '0.75rem',
                    letterSpacing: '0.02em',
                    textTransform: 'uppercase',
                    opacity: 0.8,
                    color: colors.accent.main,
                    lineHeight: 1,
                    userSelect: 'none',
                }}
            >
                {mode === 'light' ? 'Light' : 'Dark'}
            </Typography>

            <IconButton
                onClick={toggleTheme}
                aria-label={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
                sx={{
                    width: 40,
                    height: 20,
                    padding: 0,
                    position: 'relative',
                    color: colors.accent.main,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                }}
            >
                {/* Base Capsule */}
                <svg
                    width="40"
                    height="20"
                    viewBox="0 0 40 20"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                    }}
                >
                    <rect
                        x="2"
                        y="2"
                        width="36"
                        height="16"
                        rx="8"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                    />
                </svg>

                {/* Indicator Circle */}
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    style={{
                        position: 'absolute',
                        top: '4px',
                        left: mode === 'light' ? '4px' : '24px',
                        transition: 'left 0.3s ease',
                    }}
                >
                    <circle
                        cx="6"
                        cy="6"
                        r="4"
                        fill={mode === 'light' ? 'none' : 'currentColor'}
                        stroke="currentColor"
                        strokeWidth="2"
                    />
                </svg>
            </IconButton>
        </Box>
    );
};

export default ThemeToggle;
